<section class="dashboard">
  <app-navbar class="dashboard-navbar"></app-navbar>
  <!-- <app-loader *ngIf="isLoading"></app-loader> -->
  <article class="edutegia-main-content">
    <aside>
      <app-sidebar-menu></app-sidebar-menu>
    </aside>
    <main>
      <router-outlet></router-outlet>
    </main>
  </article>
</section>
